module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/331.b8f5cca7.png";